import { useCallback, useEffect, useRef, useState } from 'react';

const ROTATE_TIMEOUT = 5000;

export function useTabAutoRotation(switchToNextTab: () => void) {
  const [isEnabled, setIsEnabled] = useState(true);
  const cbRef = useRef<() => void>(switchToNextTab);
  cbRef.current = switchToNextTab;

  const timerRef = useRef<ReturnType<typeof window.setTimeout>>(undefined);

  const stop = useCallback(() => {
    clearTimeout(timerRef.current);
    if (isEnabled) setIsEnabled(false);
  }, [isEnabled, setIsEnabled, timerRef]);

  const rotate = () => {
    if (!isEnabled) return;
    cbRef.current();
    timerRef.current = setTimeout(() => {
      rotate();
    }, ROTATE_TIMEOUT);
  };

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      rotate();
    }, ROTATE_TIMEOUT);

    return () => {
      clearTimeout(timerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    stop,
    isStopped: !isEnabled,
  };
}
